const DUMMY_COLORS = [
  {
    color: 'ROYAL BLUE',
    hex: '#194fa0',
    imageName: 'Blue.png',
    imagePath: 'assets/demo/images/product/dummy-placeholders/Blue.png'
  },
  {
    color: 'PALE YELLOW',
    hex: '#f8f09f',
    imageName: 'Yellow.png',
    imagePath: 'assets/demo/images/product/dummy-placeholders/Yellow.png'
  },
  {
    color: 'OFF WHITE',
    hex: '#fafafa',
    imageName: 'White.png',
    imagePath: 'assets/demo/images/product/dummy-placeholders/White.png'
  },
  {
    color: 'CRIMSON RED',
    hex: '#a11b33',
    imageName: 'Red.png',
    imagePath: 'assets/demo/images/product/dummy-placeholders/Red.png'
  },
  {
    color: 'DEEP PURPLE',
    hex: '#380e59',
    imageName: 'Purple.png',
    imagePath: 'assets/demo/images/product/dummy-placeholders/Purple.png'
  },
  {
    color: 'OLIVE GREEN',
    hex: '#6ca11a',
    imageName: 'Green.png',
    imagePath: 'assets/demo/images/product/dummy-placeholders/Green.png'
  }
]

export const DUMMY_PRODUCTS: any[] = Array(8)
  .fill(null)
  .map((_, productIndex) => ({
    id: 1000 + productIndex,
    storefront_id: 0,
    catalog_product_id: 0,
    is_custom: 0,
    name: 'Placeholder T-Shirt',
    slug: 'placeholder-t-shirt',
    price: 0,
    price_decimal: 0,
    line_name: 'Placeholder line',
    description: 'Placeholder description for product',
    discontinued: 0,
    currency: 'usd',
    short_description: null,
    copy_underneath_description: null,
    status: 'published',
    start_publish_date: null,
    end_publish_date: null,
    library_approved: 1,
    in_progress: 0,
    disabled: 0,
    margin: 0,
    margin_decimal: 0,
    final_price: 0,
    total_cost: 0,
    need_attention: 0,
    failed: 0,

    product_thumbnail: {
      id: 0,
      name: 'placeholder.png',
      extension: 'png',
      path: 'assets/demo/images/product/dummy-placeholders/White.png',
      type: 'productThumbnail',
      full_path: 'assets/demo/images/product/dummy-placeholders/White.png',
      order: null
    },

    // Each dummy product has all 6 colors
    product_variants: DUMMY_COLORS.map((colorObj, variantIndex) => ({
      id: 10000 + productIndex * 100 + variantIndex,
      product_id: 1000 + productIndex,
      catalog_product_variant_id: 0,
      color: colorObj.color,
      primary_hex_color: colorObj.hex,
      secondary_hex_color: null,

      variant_thumbnail: {
        id: 0,
        name: colorObj.imageName,
        extension: 'png',
        path: colorObj.imagePath,
        type: 'variantImages',
        full_path: colorObj.imagePath,
        order: 0
      }
    }))
  }))
